let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2LvhT")).then(() => parcelRequire('5hqNq'));